module.exports = __webpack_public_path__ + "img/no-gps-ship.e7d1dc52.svg";